export default __webpack_public_path__ + "static/media/logo_RL_testobianco.fa0d9a98.png";